import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireMember } from '@/lib/auth-guards'
import { MyCheckInsPage } from '@/features/my-account/my-check-ins-page'

const myCheckInsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
})

export const Route = createFileRoute('/_authenticated/my-check-ins')({
  beforeLoad: requireMember,
  component: MyCheckInsPage,
  validateSearch: myCheckInsSearchSchema,
})
